import { CAROUSEL_NEXT_SLIDE, carouselSlideChangedCreator } from '../actions';
import { getCarouselSlideCount, getCarouselSlideIndex } from '../selectors';

export default store => next => action => {
  if (action.type === CAROUSEL_NEXT_SLIDE) {
    const state = store.getState();
    const { carouselSliceId } = action.payload;
    const slideIndex = getCarouselSlideIndex(state, carouselSliceId);
    const slideCount = getCarouselSlideCount(state, carouselSliceId);
    const nextSlideIndex = (slideIndex + 1) % slideCount;

    return next(carouselSlideChangedCreator(action.payload.carouselSliceId, nextSlideIndex));
  }
  return next(action);
};
